module.exports = __webpack_public_path__ + "img/square-r.e00f2660.svg";